import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";

const query = gql`
  query {
    locales: entries(section: "locales") {
      ... on locale_Entry {
        id
        title
        uri
      }
    }
  }
`;

export default () => {
  return useQuery(query);
};
